export default __webpack_public_path__ + "static/large-cabin-dining-7e3790da60d97b5595f949dd415f1abd.jpg";